import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Callout({ type = 'info', title, children, }) {
    const palette = {
        info: { bg: '#EEF6FB', border: '#0F766E', label: 'INFO', icon: 'ℹ' },
        tip: { bg: '#FDF4E6', border: '#D97706', label: 'TIPS', icon: '★' },
        warning: { bg: '#FEF7E0', border: '#B45309', label: 'PERHATIAN', icon: '⚠' },
        danger: { bg: '#FEECEC', border: '#B91C1C', label: 'PENTING', icon: '‼' },
        success: { bg: '#ECFDF5', border: '#059669', label: 'HASIL', icon: '✓' },
    };
    const p = palette[type];
    return (_jsxs("div", { style: {
            background: p.bg,
            borderLeft: `4px solid ${p.border}`,
            padding: '14px 18px',
            borderRadius: 8,
            margin: '16px 0',
        }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    fontWeight: 700,
                    fontSize: 12,
                    letterSpacing: '0.06em',
                    color: p.border,
                    marginBottom: 6,
                }, children: [_jsx("span", { style: { fontSize: 16 }, children: p.icon }), _jsx("span", { children: title ?? p.label })] }), _jsx("div", { style: { color: '#1F2937', lineHeight: 1.6 }, children: children })] }));
}
export function Kbd({ children }) {
    return (_jsx("kbd", { style: {
            background: '#F3F4F6',
            border: '1px solid #D1D5DB',
            borderBottomWidth: 2,
            borderRadius: 4,
            padding: '2px 7px',
            fontSize: 12,
            fontFamily: 'ui-monospace, SFMono-Regular, monospace',
            fontWeight: 600,
        }, children: children }));
}
export function StepList({ items }) {
    return (_jsx("ol", { style: { padding: 0, margin: 0, listStyle: 'none', counterReset: 'step' }, children: items.map((it, i) => (_jsxs("li", { style: {
                counterIncrement: 'step',
                paddingLeft: 44,
                paddingBottom: 20,
                position: 'relative',
                borderLeft: i === items.length - 1 ? 'none' : '2px solid #E5E7EB',
                marginLeft: 16,
            }, children: [_jsx("span", { style: {
                        position: 'absolute',
                        left: -16,
                        top: 0,
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        background: '#B91C1C',
                        color: '#FEF3C7',
                        display: 'grid',
                        placeItems: 'center',
                        fontWeight: 700,
                        fontSize: 14,
                    }, children: i + 1 }), _jsxs("div", { style: { paddingLeft: 20 }, children: [_jsx("h4", { style: { margin: '4px 0 8px', color: '#111827', fontSize: 15 }, children: it.title }), _jsx("div", { style: { color: '#374151', lineHeight: 1.65 }, children: it.body })] })] }, i))) }));
}
export function Screenshot({ title, children, caption, }) {
    return (_jsxs("figure", { style: { margin: '20px 0' }, children: [_jsxs("div", { style: {
                    background: '#FAFAF7',
                    border: '1px solid #E5E7EB',
                    borderRadius: 12,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                }, children: [_jsxs("div", { style: {
                            background: 'linear-gradient(180deg, #F9FAFB 0%, #F3F4F6 100%)',
                            padding: '10px 16px',
                            borderBottom: '1px solid #E5E7EB',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                        }, children: [_jsxs("span", { style: { display: 'flex', gap: 6 }, children: [_jsx("span", { style: { width: 12, height: 12, borderRadius: '50%', background: '#EF4444' } }), _jsx("span", { style: { width: 12, height: 12, borderRadius: '50%', background: '#F59E0B' } }), _jsx("span", { style: { width: 12, height: 12, borderRadius: '50%', background: '#10B981' } })] }), _jsxs("span", { style: {
                                    flex: 1,
                                    textAlign: 'center',
                                    fontSize: 12,
                                    fontFamily: 'ui-monospace, SFMono-Regular, monospace',
                                    color: '#6B7280',
                                }, children: ["hbt.wisewaysolution.com \u2014 ", title] })] }), _jsx("div", { style: { padding: 20, background: '#FFFFFF' }, children: children })] }), caption && (_jsx("figcaption", { style: {
                    textAlign: 'center',
                    fontSize: 13,
                    color: '#6B7280',
                    marginTop: 10,
                    fontStyle: 'italic',
                }, children: caption }))] }));
}
export function Highlight({ children }) {
    return (_jsx("mark", { style: {
            background: '#FEF3C7',
            color: '#7C2D12',
            padding: '1px 5px',
            borderRadius: 3,
            fontWeight: 600,
        }, children: children }));
}
export function Section({ id, title, subtitle, children, }) {
    return (_jsxs("section", { id: id, style: { marginBottom: 64, scrollMarginTop: 24 }, children: [_jsx("h2", { style: {
                    fontSize: 26,
                    margin: '0 0 6px',
                    color: '#7F1D1D',
                    borderBottom: '3px solid #B91C1C',
                    paddingBottom: 10,
                    display: 'inline-block',
                }, children: title }), subtitle && (_jsx("p", { style: { color: '#6B7280', fontSize: 15, marginTop: 8, marginBottom: 20 }, children: subtitle })), _jsx("div", { style: { marginTop: 20, fontSize: 15, lineHeight: 1.75, color: '#1F2937' }, children: children })] }));
}
export function ShortcutRow({ keys, action }) {
    return (_jsxs("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 0',
            borderBottom: '1px dashed #E5E7EB',
        }, children: [_jsx("span", { style: { color: '#374151' }, children: action }), _jsx("span", { style: { display: 'flex', gap: 6 }, children: keys.map((k, i) => (_jsxs("span", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [i > 0 && _jsx("span", { style: { color: '#9CA3AF', fontSize: 12 }, children: "+" }), _jsx(Kbd, { children: k })] }, i))) })] }));
}
export function RoleBadge({ role }) {
    const colors = {
        ADMIN_SISTEM: '#7C3AED',
        BENDAHARA: '#B91C1C',
        KETUA: '#0F766E',
        KASIR: '#D97706',
        ADMIN_MAKAM: '#059669',
        ADMIN_ABU: '#0EA5E9',
        ADMIN_TOKO: '#DC2626',
    };
    const bg = colors[role] ?? '#6B7280';
    return (_jsx("span", { style: {
            background: bg,
            color: '#FFFFFF',
            padding: '2px 10px',
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.03em',
            display: 'inline-block',
        }, children: role }));
}
